<template>
  <div class="step-container">
    <div class="row center">
      <h3 class="step-header">2. Select your boiler's fuel type</h3>
    </div>
    <div class="row center">
      <h4 class="step-sub-header">We need to ensure we send the correct engineer</h4>
    </div>
    <div class="row center">
      <button class="submit-button" @click="$emit('submit', 'gas')">
        <img class="btn-icon" :src="`${base}images/main-gas.png`" alt="gas icon">
        <span>Main Gas</span>
      </button>
      <button class="submit-button" @click="$emit('submit', 'lpg')">
        <img class="btn-icon" :src="`${base}images/lpg.png`" alt="lpg icon">
        <span>LPG</span>
      </button>
      <button class="submit-button" @click="$emit('submit', 'oil')">
        <img class="btn-icon" :src="`${base}images/heating-oil.png`" alt="oil icon">
        <span>Oil</span>
      </button>
      <button class="submit-button" @click="$emit('submit', 'electric')">
        <img class="btn-icon" :src="`${base}images/heating-electric.png`" alt="electric icon">
        <span>Electric</span>
      </button>

      <button class="submit-button" @click="$emit('submit', 'hybrid')">
        <img class="btn-icon" :src="`${base}images/heating-hybrid.png`" alt="hybrid icon">
        <span>Hybrid</span>
      </button>


    </div>
    <div class="row center back">
      <span @click="$emit('back')">Back</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "StepTwo",
  props: {
    base: {
      type: String,
      required: true,
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/steps/StepTwo.vue